module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAACCAYAAABR7VzxAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABJSURBVHgBPYxRDsAgDEJh7h7e/yD73Bm2exhFqqYkDfDSlk/tXyGrIFJUOCxiZysZZJ6dGMB/v60HX+Mj+zgpsvavlFyu3CkGExLiIY6yWIjzAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/little-bar-p.png
// module id = b4Or
// module chunks = 1